// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scratch-content {
  min-height: 100vh;
  width: 100%;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
}

.scratch-main {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 64px 24px 72px;
}

.scratch-header {
  max-width: 680px;
  margin-bottom: 30px;
}

.scratch-eyebrow {
  display: block;
  margin-bottom: 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
  color: var(--color-text-secondary);
}

.scratch-title {
  margin: 0;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(42px, 5.6vw, 68px);
  font-weight: 400;
  line-height: 1.02;
  color: var(--color-text-primary);
}

.scratch-title span {
  font-style: italic;
}

.scratch-subtitle {
  max-width: 560px;
  margin: 16px 0 0;
  font-size: 15px;
  line-height: 1.6;
  color: var(--color-text-secondary);
}

.scratch-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(280px, 0.75fr);
  gap: 18px;
  align-items: stretch;
}

.scratch-panel {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
}

.scratch-panel--form {
  padding: 22px;
}

.scratch-panel--aside {
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
}

.scratch-section-header {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  margin-bottom: 14px;
}

.scratch-section-header--assets {
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid var(--color-border-input);
}

.scratch-section-header span {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 28px;
  line-height: 1;
  color: var(--color-text-primary);
  opacity: 0.16;
}

.scratch-section-header h2,
.scratch-panel--aside h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 650;
  color: var(--color-text-primary);
}

.scratch-section-header p,
.scratch-panel--aside p {
  margin: 5px 0 0;
  font-size: 13px;
  line-height: 1.55;
  color: var(--color-text-secondary);
}

.scratch-description {
  width: 100%;
  display: block;
  box-sizing: border-box;
  padding: 13px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  line-height: 1.6;
  resize: vertical;
  outline: 0;
}

.scratch-description:focus {
  border-color: var(--color-text-secondary);
}

.scratch-description::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.72;
}

.scratch-file-input {
  display: none;
}

.scratch-upload-zone {
  width: 100%;
  min-height: 92px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px dashed var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.scratch-upload-zone:hover {
  border-color: var(--color-text-secondary);
  background: var(--color-bg-user-bubble);
}

.scratch-upload-zone span {
  font-size: 13px;
  font-weight: 650;
}

.scratch-upload-zone small {
  color: var(--color-text-secondary);
  font-size: 11px;
}

.scratch-assets-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.scratch-asset-row {
  min-height: 50px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
}

.scratch-asset-icon {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
}

.scratch-asset-icon--image {
  color: #93c66c;
}

.scratch-asset-icon--video {
  color: #56b6de;
}

.scratch-asset-icon--audio {
  color: #de7fa6;
}

.scratch-asset-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.scratch-asset-meta strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 600;
}

.scratch-asset-meta small {
  color: var(--color-text-secondary);
  font-size: 11px;
  text-transform: capitalize;
}

.scratch-asset-row button {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  cursor: pointer;
}

.scratch-submit {
  width: 100%;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
  padding: 0 20px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-text-primary);
  color: var(--color-bg-root);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.scratch-submit:hover:not(:disabled) {
  opacity: 0.88;
  transform: translateY(-1px);
}

.scratch-submit:disabled {
  opacity: 0.36;
  cursor: not-allowed;
  transform: none;
}

.scratch-spinner {
  width: 18px;
  height: 18px;
  display: inline-block;
  border: 2px solid rgba(0, 0, 0, 0.22);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: scratch-spin 0.65s linear infinite;
}

@keyframes scratch-spin {
  to { transform: rotate(360deg); }
}

.scratch-error {
  display: block;
  margin-top: 10px;
  color: #ef4444;
  font-size: 12px;
  text-align: center;
}

.scratch-aside-icon {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: #56b6de;
}

.scratch-aside-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.scratch-aside-steps span {
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
}

@media (max-width: 920px) {
  .scratch-grid {
    grid-template-columns: 1fr;
  }

  .scratch-panel--aside {
    justify-content: flex-start;
  }
}

@media (max-width: 680px) {
  .scratch-main {
    padding: 38px 16px 56px;
  }

  .scratch-title {
    font-size: 42px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ScratchVideoTemplatePage.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gCAAgC;EAChC,gCAAgC;EAChC,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,aAAa;AACf;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4CAA4C;EAC5C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,2BAA2B;EAC3B,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap');\n\n.scratch-content {\n  min-height: 100vh;\n  width: 100%;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n}\n\n.scratch-main {\n  width: 100%;\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 64px 24px 72px;\n}\n\n.scratch-header {\n  max-width: 680px;\n  margin-bottom: 30px;\n}\n\n.scratch-eyebrow {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  color: var(--color-text-secondary);\n}\n\n.scratch-title {\n  margin: 0;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(42px, 5.6vw, 68px);\n  font-weight: 400;\n  line-height: 1.02;\n  color: var(--color-text-primary);\n}\n\n.scratch-title span {\n  font-style: italic;\n}\n\n.scratch-subtitle {\n  max-width: 560px;\n  margin: 16px 0 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--color-text-secondary);\n}\n\n.scratch-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(280px, 0.75fr);\n  gap: 18px;\n  align-items: stretch;\n}\n\n.scratch-panel {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n}\n\n.scratch-panel--form {\n  padding: 22px;\n}\n\n.scratch-panel--aside {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 14px;\n}\n\n.scratch-section-header {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  margin-bottom: 14px;\n}\n\n.scratch-section-header--assets {\n  margin-top: 20px;\n  padding-top: 18px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.scratch-section-header span {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 28px;\n  line-height: 1;\n  color: var(--color-text-primary);\n  opacity: 0.16;\n}\n\n.scratch-section-header h2,\n.scratch-panel--aside h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 650;\n  color: var(--color-text-primary);\n}\n\n.scratch-section-header p,\n.scratch-panel--aside p {\n  margin: 5px 0 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--color-text-secondary);\n}\n\n.scratch-description {\n  width: 100%;\n  display: block;\n  box-sizing: border-box;\n  padding: 13px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  line-height: 1.6;\n  resize: vertical;\n  outline: 0;\n}\n\n.scratch-description:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.scratch-description::placeholder {\n  color: var(--color-text-secondary);\n  opacity: 0.72;\n}\n\n.scratch-file-input {\n  display: none;\n}\n\n.scratch-upload-zone {\n  width: 100%;\n  min-height: 92px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: 1px dashed var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.scratch-upload-zone:hover {\n  border-color: var(--color-text-secondary);\n  background: var(--color-bg-user-bubble);\n}\n\n.scratch-upload-zone span {\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.scratch-upload-zone small {\n  color: var(--color-text-secondary);\n  font-size: 11px;\n}\n\n.scratch-assets-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.scratch-asset-row {\n  min-height: 50px;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n}\n\n.scratch-asset-icon {\n  width: 34px;\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n}\n\n.scratch-asset-icon--image {\n  color: #93c66c;\n}\n\n.scratch-asset-icon--video {\n  color: #56b6de;\n}\n\n.scratch-asset-icon--audio {\n  color: #de7fa6;\n}\n\n.scratch-asset-meta {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.scratch-asset-meta strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.scratch-asset-meta small {\n  color: var(--color-text-secondary);\n  font-size: 11px;\n  text-transform: capitalize;\n}\n\n.scratch-asset-row button {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n}\n\n.scratch-submit {\n  width: 100%;\n  min-height: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 18px;\n  padding: 0 20px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-text-primary);\n  color: var(--color-bg-root);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 650;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.scratch-submit:hover:not(:disabled) {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.scratch-submit:disabled {\n  opacity: 0.36;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.scratch-spinner {\n  width: 18px;\n  height: 18px;\n  display: inline-block;\n  border: 2px solid rgba(0, 0, 0, 0.22);\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: scratch-spin 0.65s linear infinite;\n}\n\n@keyframes scratch-spin {\n  to { transform: rotate(360deg); }\n}\n\n.scratch-error {\n  display: block;\n  margin-top: 10px;\n  color: #ef4444;\n  font-size: 12px;\n  text-align: center;\n}\n\n.scratch-aside-icon {\n  width: 48px;\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: #56b6de;\n}\n\n.scratch-aside-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.scratch-aside-steps span {\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n@media (max-width: 920px) {\n  .scratch-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .scratch-panel--aside {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 680px) {\n  .scratch-main {\n    padding: 38px 16px 56px;\n  }\n\n  .scratch-title {\n    font-size: 42px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
